module.exports = __webpack_public_path__ + "img/subaruf.e9344857.png";